
const formateMeaData = (meaData, type, Intl) => {
    const maskSlotTitle = (type) => {
        let title = ''
        switch(type){
            case 'height':
                title = Intl.formatMessage({id: 'height'})
                break
            case 'weight':
                title = Intl.formatMessage({id: 'weight'})
                break
            case 'bust':
                title = Intl.formatMessage({id: 'bust_size'})
                break
            case 'bra':
                title = Intl.formatMessage({id: 'bra_size'})
                break
            case 'hips':
                title = Intl.formatMessage({id: 'hips'})
                break
            case 'waist':
                title = Intl.formatMessage({id: 'waist'})
                break
        }
        return title
    }

    const maskUnitList = (data) => {
        if(data?.length > 0 && (typeof(data?.[0]) == 'object')){
            return Object.keys(data[0])
        }
        return ''
    }

    let data = meaData?.[type] || []
    let unitLabel = type + 'Unit'
    const obj = {
        slotTitle: maskSlotTitle(type),
        unitList: maskUnitList(data),
        selectList: data,
        slotDefaultV: '',
        unit: maskUnitList(data)?.[0],
        valueLabel: type,
        unitLabel: unitLabel,
    }
    return obj
}

export default formateMeaData